import { FunctionComponent as F } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Box from "@mui/material/Box";
import { deleteFolderAsync } from "../../core/store/protocol/protocolFolder.thunks";
import { useAppDispatch } from "../../core/store/hooks";
import { useSelector } from 'react-redux';
import { IState } from "../../core/store/store";
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import Button from '../UI/Button/Button';



interface Params
{
  protocolId?: string
}

interface Props
{
  folderId: number,
  open: boolean,
  close: () => void
}

const DeleteFolderDialog: F<Props> = (props: Props) =>
{
  const appDispatch = useAppDispatch();
  const navigate = useNavigate();
  const params: Params = useParams();
  const folder = useSelector((state: IState) =>
    state.protocol.folders.find(p => p.folderId === props.folderId));
  if(!folder)
    return <></>;
  const protocols = useSelector((state: IState) => state.protocol.protocols);
  const folderProtocols = useSelector((state: IState) =>
    state.protocol.protocols.filter(p => p.folderId === props.folderId));

  const handleConfirmDelete = () =>
  {
    props.close();

    if(folderProtocols.map(p => p.protocolId).includes(Number(params.protocolId)))
    {
      navigate(location.pathname.replace(
        /\/protocol\/\d*/,
        "/protocol/" + protocols.find(p => p.protocolId !== Number(params.protocolId))?.protocolId));
    }

    appDispatch(deleteFolderAsync(props.folderId));
  }

  return (
    <Dialog
      open={props.open}
      maxWidth='md'
      PaperProps={{ sx: { p: '15px', textAlign: 'center' }}}
      onClose={props.close}>
      <DialogTitle sx={{ fontSize: '30px' }}>Delete folder</DialogTitle>
      <DialogContent>
        <Typography variant='body2' sx={{ paddingBottom: '24px' }}>
          {folder.name + " and all protocols contained within it will be removed permanently."}
          <br/>
          {"Are you sure you want to proceed?"}
        </Typography>
        <Button
          label='Cancel'
          onClick={props.close}/>
        <Button
          onClick={handleConfirmDelete}
          label='Ok'/>
        <Box style={{ display: 'inline', paddingLeft: '14px' }} />
      </DialogContent>
    </Dialog>);
}

export default DeleteFolderDialog;

